import { render } from "./devices.vue?vue&type=template&id=2decc25b"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"

import "./devices.vue?vue&type=style&index=0&id=2decc25b&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__